import Vue from 'vue'
// 按需引入vant
import { PullRefresh, List, Tabbar, TabbarItem, Tab, Tabs, Cell, CellGroup } from 'vant';

Vue.use(PullRefresh);
Vue.use(List);
Vue.use(Tabbar);
Vue.use(TabbarItem);
Vue.use(Tab);
Vue.use(Tabs);
Vue.use(Cell);
Vue.use(CellGroup);